import { IsNotEmpty, IsString, MaxLength } from 'class-validator';
import { TeamAccessEditDTO } from '../team/team-access-edit.dto';

export class CannedResponseEditDTO extends TeamAccessEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(255)
    name: string;

    @IsNotEmpty()
    @IsString()
    content: string;

}
